export const tr = {
    'error-message': 'Sorgu yapılamadı, daha sonra tekrar deneyin.',
    'freelancer-page-header': 'Yandex.Direct uzmanı',
    'withdraw-coop-success':
        'Uzman sorgusunu iptal ettiniz. Çözüm ortaklığı için başka bir uzman seçebilir veya bu kişiye tekrar sorgu gönderebilirsiniz.'
};
